import React from 'react';
import ActivityTable from '../ActivityTable';

export default function Activity() {
  return <ActivityTable />;
}
